export const useUserPrintingAppStore = defineStore('userPrintingApp', () => {
  const { $api } = useNuxtApp()

  function directPrint(tournamentId: number | null, game: Game | null, group: number | null = null, group_individual: boolean = false) {
    if (null === tournamentId) {
      return
    }
    $api('/tournaments/{tournament}/print', {
      method: 'post',
      path: {
        tournament: tournamentId,
      },
      body: {
        game_id: game?.id,
        group_number: group,
        group_individual: group_individual,
      },
    }).then((data) => {
      const winPrint = window.open('', '', 'left=0,top=0,width=800,height=auto,toolbar=0,scrollbars=0,status=0')
      if (!winPrint) {
        return
      }
      winPrint.document.write(atob(data.html))
      winPrint.document.close()
      winPrint.focus()
      winPrint.addEventListener('load', function () {
        winPrint.print()
        winPrint.close()
      })

      if (game) {
        game.printed = true
      }
    })
  }

  return { directPrint }
})
